/* eslint-disable jam3/no-sanitizer-with-danger */

import React, { useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link } from 'react-router-dom'
import styles from './View.Style';
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import noDraftIdeasImg from 'img/no_draft_idea.png'
import InvestorsImg from 'img/imgs/investors.svg';
import { Container, Stepper, Step, StepLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams, useLocation } from 'react-router-dom'

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { IdeaDetails } from './IdeaDetails';
import { IdeaGenerateForm } from './IdeaGeneratedForm';
import { IdeaConfirmAndSubmit } from './ideaConfirmAndSubmit';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import CustomButton from 'components_newui/customButton/CustomButton';

// import NxtCircularLoader from 'components/nxt_circular_loader/View'





const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  title: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '2.125rem',
    margin: '1rem 0 2rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  titleSub: {
    fontFamily: 'VodafoneRg-bold',
    fontSize: '1.5rem',
    margin: '1rem 0 1rem 0',
    textAlign: 'center',
    paddingTop: '1rem',
    color: '#333',
  },
  summary: {
    fontFamily: 'VodafoneRg-Regular',
    fontSize: '1.125rem',
    lineHeight:'1.5',
    margin: '1rem 0 1rem 0',
    textAlign: 'left',
    paddingTop: '1rem',
    color: '#333',
  },
  backButton: { marginRight: theme.spacing(1) },
  instructions: { marginTop: theme.spacing(1), marginBottom: theme.spacing(1) },
  instructions1: { marginTop: theme.spacing(1), marginBottom: theme.spacing(3) },
}));


const defaultValues = {
  challengeKey: '',
  ideaKey: '',
  market: '',
  businessUnit: '',
  title: '',
  summary: '',
  documentsKey: undefined,
  coverPhoto: [],
  addInfo: '',
  ideaTemplate: null,
  ideaTemplateAnswers: null,
};


const stepConfig = [
  {
    label: 'Idea Details',
    component: IdeaDetails,
    validationSchema: yup.object({
      title: yup.string()
        .min(3, 'Minimum 3 characters')
        .max(100, 'Maximum 100 characters')
        .required()
        .trim()
        .matches(
          /^[a-zA-Z0-9_ #!?|]*$/,
          'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
        ),
        // .matches(
        //   /^[a-zA-Z0-9_ #!?]*$/,
        //   'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), and question mark (?) are allowed'
        // ),
      summary: yup.string().required().trim(),
      market: yup.string().required(),
      businessUnit: yup.string().required(),
      coverPhoto: yup.array()
        .of(
          yup
            .mixed()
            .test(
              'fileSize',
              'Image must be less than 10 MB',
              (value) => {
                console.log("🚀 ~ value validation:", value)
                const file = value?.file;
                if (!file || typeof file.size !== 'number') return false;
                return file.size / (1024 * 1024) <= 10;
              }
            )
        )
        .min(1, 'At least one image is required')
        .required('Cover photo is required'),


    }),
    // title: yup.string().required(),
    // summary: yup.string().required(),
    // market: yup.string().required(),
    // businessUnit: yup.string().required(),
    // coverPhoto: yup.array().required(),
    // // termsAndConditions: yup.string().required(),
    // }),
  },
  {
    label: 'Tell Us More',
    component: IdeaGenerateForm,
    validationSchema: yup.object({
      // templateIdea: yup.object().required(),
    }),
  },
  {
    label: 'Confirm & Submit',
    component: IdeaConfirmAndSubmit,
    validationSchema: yup.object({
      // templateIdea: yup.object().required(),
    }),
  },
  // {
  //   label: 'Challenge Summary',
  //   component: ChallengePreview,
  //   validationSchema: yup.object(),
  // },
];


const IdeaSubmit = (props) => {

  // console.log("🚀 ~ IdeaSubmit [[][][][][][][]] props:", props)


  const { isAdmin,isEvaluator ,myEmail:loginEmail , getInnovateIdeaImageLoading,getInnovateIdeaImage, getInnovateCreateIdeaPublishLoading, getInnovateCreateIdeaDraftData, getInnovateIdeaDocumentUploadList = [], postInnovateCreateIdeaPublishFn, getInnovateCreateIdeaDraftLoading, getInnovateIdeaDraftID, getInitialInnovateIdeaDraftFn, postInnovateCreateIdeaDraftFn, getInnovateIdeaTemplateIdJsonFn, getInnovateIdeaTemplateIdJsonLoading, getInnovateIdeaTemplateIdJson } = props || {}
  const location = useLocation();
  const challengeSelectedData = location.state?.challenge;
  const { id: draftIdeaKey, owner:ownerEmail } = getInnovateIdeaDraftID || {}
  const { idea: listReponseDraftID } = getInnovateCreateIdeaDraftData
  // console.log("🚀 ~ IdeaSubmit ~ challengeSelectedData:", challengeSelectedData)
  const { title = '',  desc='', ideaTemplateId = 0, id: challengeKeyID, termAndCondition } = challengeSelectedData || {}
  const { id: ideaId } = useParams();
  const classes = useStyles();
  const [getAnswerFromIdeaToDynamicForm, setGetDatafromDynamicFormIdea] = useState([]);
  const [dialogOpenForChallengeTnc, setDialogOpenForChallengeTnc] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [isValidField, setIsValidField] = useState(false);
  const [isValidFormDynamicField, setIsValidFormDynamicField] = useState(false);
  const currentStep = stepConfig[activeStep];

  const copyArrgetInnovateIdeaDocumentUpload = getInnovateIdeaDocumentUploadList || []
  // console.log("🚀 ~ IdeaSubmit ~ copyArrgetInnovateIdeaDocumentUpload:", copyArrgetInnovateIdeaDocumentUpload)

  // console.log("🚀 ~ IdeaSubmit ~ copyArrgetInnovateIdeaDocumentUpload:", copyArrgetInnovateIdeaDocumentUpload)
  // const allDocumentKey = copyArrgetInnovateIdeaDocumentUpload?.map(file => {
  //   // console.log("file..",file)
  //    return file?.key
  // });
  // console.log("🚀 ~ IdeaSubmit ~ allDocumentKey:", listReponseDraftID )

  const onHandleViewChallengeTnc = () => {
    setDialogOpenForChallengeTnc((prev) => !prev)
  }

  const methods = useForm({
    defaultValues,
    resolver: yupResolver(currentStep?.validationSchema),
    mode: 'onChange',
  });

  const { handleSubmit, trigger, getValues, reset } = methods;
  // console.log("🚀 ~ IdeaSubmit ~ getValues:", getValues)

  const handleIdeaTemplateIJson = async () => {
    const isValidId = Number(ideaTemplateId);
    if (!isValidId) return;

    try {
      const isValid = await trigger();
      setIsValidField(isValid)
      await getInnovateIdeaTemplateIdJsonFn(ideaTemplateId);
      window.scrollTo(0, 0)
      // Start polling every 300ms to check if loading is done
      // const pollInterval = setInterval(async () => {
      //   if (!!getInnovateIdeaTemplateIdJsonLoading) {
      //     clearInterval(pollInterval); // Stop polling

      //     const isValid = await trigger();
      //     if (isValid) {
      //       setActiveStep(prev => prev + 1);
      //     }
      //   }
      // }, 300);


    } catch (error) {
      console.error('Error fetching idea template JSON:', error);
    }
  };




  // useEffect( async ()=>{
  //   const isValidId = Number(ideaTemplateId);
  //   if (!isValidId) return;
  //   try {
  //     const isValid = await trigger();
  //     setIsValidField(isValid)
  //     await getInnovateIdeaTemplateIdJsonFn(isValidId);

  //     // Start polling every 300ms to check if loading is done
  //     // const pollInterval = setInterval(async () => {
  //     //   if (!!getInnovateIdeaTemplateIdJsonLoading) {
  //     //     clearInterval(pollInterval); // Stop polling

  //     //     const isValid = await trigger();
  //     //     if (isValid) {
  //     //       setActiveStep(prev => prev + 1);
  //     //     }
  //     //   }
  //     // }, 300);


  //   } catch (error) {
  //     console.error('Error fetching idea template JSON:', error);
  //   }
  // },[])


  useEffect(() => {
    getInitialInnovateIdeaDraftFn?.()
  }, [])


  const nextStepsAfterFormSubmit = async () => {
    const isValid = await trigger();
    // console.log("Validation result:", isValid);

    if (isValid) {
      setIsValidFormDynamicField(true);
      window.scrollTo(0, 0)
      // Proceed to next step
    } else {
      setIsValidFormDynamicField(false);
    }
  };


  // const nextStepsAfterFormSubmit = async ()=>{
  //   // alert('')
  //     const isValid = await trigger();
  //     console.log("isVAlllllllllllll inside", isValid)
  //      setIsValidFormDynamicField(prev => !prev )
  // }

  // console.log('isValidFormDynamicField on next button click', isValidFormDynamicField)


  //Start polling approach to check api response success check based on value using useEffect
  useEffect(() => {
    const checkAndProceed = async () => {
      // console.log("checkAndProceed = getInnovateIdeaTemplateIdJsonLoading", !getInnovateIdeaTemplateIdJsonLoading, getInnovateIdeaTemplateIdJsonLoading)
      if (!getInnovateIdeaTemplateIdJsonLoading) {
        if (isValidField) {
          setActiveStep(prev => prev + 1);
        }
      }
    };

    checkAndProceed();
  }, [getInnovateIdeaTemplateIdJsonLoading]);


  //Start polling approach to check api response success check based on value using useEffect
  useEffect(() => {
    const checkAndProceedFormSteps = async () => {
      if (isValidFormDynamicField) {
        setActiveStep(prev => prev + 1);
      }
    };
    checkAndProceedFormSteps();
  }, [isValidFormDynamicField]);


  const childToParentformDatatoUpdate = (data) => {
    setGetDatafromDynamicFormIdea(data)
  }


  //before submit idea form data value marge into json
  function isNonEmptyArray(variable) {
    return Array.isArray(variable) && variable.length > 0;
  }

  let mergedQuestionAndAnswerJsonData
  if (isNonEmptyArray(getAnswerFromIdeaToDynamicForm)) {
    mergedQuestionAndAnswerJsonData = getInnovateIdeaTemplateIdJson.map(item => {
      const match = getAnswerFromIdeaToDynamicForm.find(o => o.id === item.id);
      // console.log("value merge:", match)
      return {
        ...item,
        value: match ? match.value : item.value
      };
    });
  }

  // console.log('jsonforn output final json passto backend:---',  mergedQuestionAndAnswerJsonData);


  const handleNext = async () => {
    const isValid = await trigger();
    if (isValid) setActiveStep((prev) => prev + 1);
    window.scrollTo(0, 0)
  };

  const handleBack = () => {
    setIsValidFormDynamicField(false);
    setActiveStep((prev) => prev - 1);
    window.scrollTo(0, 0)
  }

  const handleReset = () => {
    reset(defaultValues);
    setActiveStep(0);
  };

  const onSubmitAllForm = (data) => {
    // if (challengeId) {
    //   putInnovateChallengeEditFn(data)
    //   alert('Challenge updated:')
    // }
    alert('idea on submit', data);
    // postInnovateChallengeCreateFn(data,showEmail)
    // handleNext();
  };


  // submit idea
  const handleSubmitIdea = async (formparams) => {

    const allGetParamsFormInputValue = methods.getValues();

    const getnameImage = getInnovateIdeaImage?.name?.trim()  || "";
        if (!getnameImage) {
        methods.setError("coverPhoto", {
          type: "required",
          message: "Cover photo is required.",
        });
        alert("Submit blocked: Please Upload the image, it seems to be no uploaded correctly");
        return;
      }

    try {

      const allIdeaParamsSubmit = {
        ...allGetParamsFormInputValue,
        ideaKey: draftIdeaKey,
        challengeKey: challengeKeyID,
        documentsKey: copyArrgetInnovateIdeaDocumentUpload || [],
        ideaTemplate: mergedQuestionAndAnswerJsonData,
        ideaTemplateAnswers: getAnswerFromIdeaToDynamicForm,
        coverPhoto: getnameImage
      };

      if (
        Array.isArray(getAnswerFromIdeaToDynamicForm) &&
        getAnswerFromIdeaToDynamicForm.length === 0 &&
        challengeKeyID === ''
      ) {
        console.warn("submit not saved: Empty answers and missing challengeKeyID.");
        return;
      }
      await postInnovateCreateIdeaPublishFn(allIdeaParamsSubmit);
      // }
      console.log("submit saved successfully.");
    } catch (error) {
      console.error("Error saving submit:", error);
      // Optionally show a user-friendly error message
      // e.g., toast.error("Failed to save draft. Please try again.");
    }
  }


  // dfraft api call
  const handleSaveDraft = async () => {
    try {
      const allDataDraft = methods.getValues();

          const getnameImage = getInnovateIdeaImage?.name?.trim()  || "";
            if (!getnameImage) {
            methods.setError("coverPhoto", {
              type: "required",
              message: "Cover photo is required.",
            });
            alert("Draft blocked: Please Upload the image, it seems to be no uploaded correctly");
            return;
          }

      const allDataDraftIdea = {
        ...allDataDraft,
        ideaKey: draftIdeaKey,
        challengeKey: challengeKeyID,
        documentsKey: copyArrgetInnovateIdeaDocumentUpload || [],
        ideaTemplate: mergedQuestionAndAnswerJsonData,
        ideaTemplateAnswers: getAnswerFromIdeaToDynamicForm,
        coverPhoto:getnameImage
      };

      // Check conditions before proceeding
      if (
        Array.isArray(getAnswerFromIdeaToDynamicForm) &&
        getAnswerFromIdeaToDynamicForm.length === 0 &&
        challengeKeyID === ''
      ) {
        console.warn("Draft not saved: Empty answers and missing challengeKeyID.");
        return;
      }
      await postInnovateCreateIdeaDraftFn(allDataDraftIdea);
      console.log("Draft saved successfully.");
    } catch (error) {
      console.error("Error saving draft:", error);
      // Optionally show a user-friendly error message
      // e.g., toast.error("Failed to save draft. Please try again.");
    }
  };




  // const handleSaveDraft = async () => {
  //   const allData = methods.getValues();
  //   // console.log("allData======>",allData,mergedQuestionAndAnswerJsonData,getAnswerFromIdeaToDynamicForm)

  //   const allDraftIdea = {
  //     ...allData,
  //     ideaKey:ideaTemplateId,
  //     challengeKey:challengeKeyID,
  //     ideaTemplate:mergedQuestionAndAnswerJsonData,
  //     ideaTemplateAnswers:getAnswerFromIdeaToDynamicForm,
  //   }

  //   // console.log("🚀 ~ handleSaveDraft ~ allDraftIdea:", allDraftIdea)

  //   postInnovateCreateIdeaDraftFn(allDraftIdea)

  //   // await saveDraftChallengeToBackend(allData,showEmail); // API call
  // };


  const isOwnerInnovate = ownerEmail === loginEmail
  const valuaget = methods.getValues();
  // console.log("🚀 ~ IdeaSubmit ~ isOwnerInnovate:", isOwnerInnovate, valuaget)

  const StepComponent = currentStep?.component;

  let buttonContent;

  if (activeStep === 0) {
    buttonContent = (
       <CustomButton  
          type="button"
        onClick={handleIdeaTemplateIJson}
        variant="contained"
        color="primary"
        disabled={getInnovateIdeaTemplateIdJsonLoading || getInnovateIdeaImageLoading}
      >
        {getInnovateIdeaTemplateIdJsonLoading ? 'Loading...' : 'Next'}
      </CustomButton>
    );
  }
  else if (activeStep === 1) {
    buttonContent = null
  }
  else {
    buttonContent = (

        <CustomButton  
          type="button"
          variant="contained"
          color="primary"
          size="large"
          className="vf-custom-nextbtn"
          onClick={ handleNext }
        >   Next </CustomButton>
    );
  }


  return (
    <Container>

      <h2 className={classes.title}> {ideaId ? 'Edit Idea' : 'Create New Idea'} </h2>
      <div className={classes.root}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {stepConfig.map((step) => (
            <Step key={step.label}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <div className={classes.instructions}>  <h3 className={classes.titleSub}>  Challenge tagged - {title}</h3> </div>
       
        {activeStep === 0 && <div className={classes.instructions}> <h3 className={classes.summary}>Challenge description</h3>  <div dangerouslySetInnerHTML={{ __html: desc }} /> </div> } 
        {activeStep === stepConfig.length ? (
          <div>
            <p className={classes.instructions}>All steps completed</p>
             <CustomButton  
          type="button"
          variant="contained" onClick={handleReset}>Reset</CustomButton>
          </div>
        ) : (
          <FormProvider {...methods}>
            <div className='formlevel' >
              <div className={classes.instructions}>
                <StepComponent
                  {...props}
                  formData={getValues()}
                  isAdmin ={isAdmin}
                  isOwnerInnovate={ownerEmail === loginEmail}
                  isEvaluator= {isEvaluator}
                  nextStepsAfterFormSubmit={nextStepsAfterFormSubmit}
                  getAnswerFromIdeaToDynamicForm={getAnswerFromIdeaToDynamicForm}
                  handleFormChange={childToParentformDatatoUpdate}
                  termAndCondition={termAndCondition}
                  />
              </div>

              <div className={classes.instructions1}>
                <CustomButton
                  type='button'
                  disabled={activeStep === 0}
                  onClick={handleBack}
                  className={classes.backButton}
                >
                  Back
                </CustomButton>

                {activeStep === stepConfig.length - 1 ? (
                  <>
                    {/* <Button
                      onClick={onHandleViewChallengeTnc}
                      className={classes.backButton}
                      variant="contained"
                      color="primary"
                      disabled={getInnovateCreateIdeaDraftLoading}
                    >
                      View Challenge T&C
                    </Button> */}
                    <CustomButton
                      type='button'
                      onClick={handleSaveDraft}
                      variant="contained"
                      color="primary"
                      className={classes.backButton}
                      disabled={getInnovateCreateIdeaDraftLoading}
                    >
                      Draft
                    </CustomButton>
                    <CustomButton
                      type='button'
                      onClick={handleSubmitIdea}
                      variant="contained"
                      disabled={getInnovateCreateIdeaPublishLoading || !(valuaget?.tncIdea)}
                      color="primary"
                    >
                      Submit Idea
                    </CustomButton>

                    {/* <Button type="submit" onSubmit={handleSubmit(onSubmitAllForm)} variant="contained" color="primary">
                    Submit Idea
                  </Button> */}
                  </>
                ) : (buttonContent)

                }
              </div>
            </div>
          </FormProvider>
        )}
      </div>
      {/* {
        dialogOpenForChallengeTnc && (
          <CommonDialog
            open={dialogOpenForChallengeTnc}
            title="Challenge T&C's"
            cancelText='Close'
            hideSubmitBtn
            content={<p>{termAndCondition}</p>}
            onClose={() => setDialogOpenForChallengeTnc(false)}

          />
        )
      } */}
    </Container>

  );
}


export default withStyles(styles)(IdeaSubmit)

